import {
    FacebookService,
    InitParams,
    LoginResponse,
    LoginOptions,
    UIResponse,
    UIParams,
    FBVideoComponent,
    LoginStatus
} from "ngx-facebook";
import { Workspace } from "./workspace.data";
import { callNextAsync } from "../services/BaseService";

export class socialMedia {
    private _fb: FacebookService = new FacebookService();
    private _FaceBookLoginState: boolean = false;
    public faceBookPosts: IFaceBookPost[] = [];

    private _facebookAccountId: string = "";
    public get facebookAccountId(): string {
        return this._facebookAccountId;
    }
    public set facebookAccountId(value: string) {
        this._facebookAccountId = value;
    }

    public get isLoggedToFacebook(): boolean {
        return this._FaceBookLoginState;
    }
    public set isLoggedToFacebook(value: boolean) {
        if (value == true) {
            this.facebook_getProfile();
        }

        this._FaceBookLoginState = value;
    }

    public get FacebookAcc(): FacebookService {
        return this._fb;
    }
    public set FacebookAcc(value: FacebookService) {
        this._fb = value;
    }

    constructor(public workspace: Workspace) {}

    Init() {
        this.facebook_Init();
    }

    facebook_Init() {
        // console.log("Initializing Facebook");

        // this.FacebookAcc.init({
        //     appId: "352500418698997",

        //     xfbml: true,
        //     version: "v3.2"
        // });

        // this.facebook_getLoginStatus();
    }

    public loginOptions: LoginOptions = {
        enable_profile_selector: true,
        return_scopes: true,
        scope: "public_profile,user_posts,user_tagged_places,manage_pages,publish_pages,email,pages_show_list"
    };

    facebook_LoginWithOptions() {
        this.FacebookAcc.login(this.loginOptions)
            .then((res: LoginResponse) => {
                console.log(res.status);

                this.isLoggedToFacebook = res.status == "connected" ? true : false;
            })
            .catch(this.handleError);
    }

    facebook_getLoginStatus() {
        this.FacebookAcc.getLoginStatus()
            .then((res: LoginStatus) => {
                console.log("res.status");
                console.log(res.status);
                this.isLoggedToFacebook = res.status == "connected" ? true : false;
            })
            .catch(console.error.bind(console));
    }

    facebook_getProfile() {
        this.FacebookAcc.api("/me")
            .then((res: any) => {
                console.log("Got the users profile", res);
                this.facebookAccountId = res.id;
                this.updatePostList();
            })
            .catch(this.handleError);
    }

    public updatePostList() {
        this.FacebookAcc.api(
            "/" + this.facebookAccountId + "/feed?fields=id,message,picture,shares,created_time,link,permalink_url"
        )
            .then((res: any) => {
                console.log("POSTSRES", res);
                this.faceBookPosts = res.data;
                console.log(this.faceBookPosts);
                this.lastFacebookPost = this.faceBookPosts[0];
                this.lastFacebookPost = this.lastFacebookPost;
                callNextAsync(this.workspace.loadedFacebookPosts, true);
            })
            .catch(this.handleError);
    }

    doNewPost() {
        console.log("this.workspace.socialMedia.facebookAccountId");
        console.log(this.workspace.socialMedia.facebookAccountId);

        this.workspace.socialMedia.FacebookAcc.ui(
            {
                method: "share",
                href: "http://dix.infosystrade.com/sharetest/testshare.html"
            }
            //       }
            //   {
            //   method: 'share_open_graph',
            //   action_type: 'og.likes',
            //   app_id:'352500418698997',
            //    display:"popup",

            //   action_properties: JSON.stringify({
            //       object: {
            //           'og:url': "http://localhost:5000",
            //           'og:title': "Posting",
            //  'og:image:width' : '1200',
            //      'og:image:height' :'675',
            //     'og:description': "overrideDescription",
            //     'og:image': "https://www.itrucker.com/wp-content/uploads/2019/01/silver-gats-pete-1200x675.jpg"
            //      }
            //   })
            // }
            // {
            //     method: 'share',
            //     href: 'http://localhost:5000',     // The same than link in feed method
            //    // title: 'your_title',  // The same than name in feed method
            //   //  picture: 'path_to_your_picture',
            //     caption: 'your_caption',
            //     description: 'your_description',
            // }
        )
            .then((res: any) => {
                console.log("SHARESEND", res);
                this.updatePostList();
            })
            .catch(this.workspace.socialMedia.handleError);
    }

    public handleError(error: any) {
        console.error("Error processing action", error);
    }

    private _lastPost: IFaceBookPost = {
        message: "",
        id: "",
        created_time: "",
        picture: "",
        shares: "",
        permalink_url: ""
    };
    public get lastFacebookPost(): IFaceBookPost {
        return this._lastPost;
    }
    public set lastFacebookPost(value: IFaceBookPost) {
        this._lastPost = value;
    }
}

export interface IFaceBookPost {
    message: string;
    id: string;
    created_time: string;
    picture: string;
    shares: string;
    permalink_url: string;
}
